import React from 'react'
import dynamic from 'next/dynamic'
import HeroSection from '../../../shared/Rewrite/BrandPages/HeroSection'
import BrandSection from '../../../shared/Rewrite/BrandPages/BrandSection'
import ColumnToRowComponent from '../../../shared/Rewrite/BrandPages/BrandSection/ColumnToRowComponent'
import BlueSection from '../../../shared/Rewrite/BrandPages/BlueSection'
import BottomSection from '../../../shared/Rewrite/BrandPages/BottomSection'
import OurPrinciplesSlider from '../../../shared/Rewrite/BrandPages/OurPrinciplesSlider'
import RecommendedReads from '../../../shared/Rewrite/BrandPages//RecommendedReads'
import Content from '../../../shared/BrandPages/Content'
import Section from '../../../shared/BrandPages/Section'
import { aboutUsContent } from './consts'
import styles from './index.module.scss'
import WithSeoOverrides from 'src/components/shared/WithSeoOverride'
import Leaders from 'src/components/shared/Rewrite/BrandPages/Leaders'
import { useTrustMarkers } from 'src/common/trust-markers'
import { numberFormat } from 'src/common/utils'

const AsFeaturedInComp = dynamic(() =>
  import('../../../shared/Rewrite/BrandPages/AsFeaturedIn')
)

const AboutPage = ({ showScheduleACallButton }) => {
  const {
    seo,
    heroData,
    ourStoryData,
    ourPrinciplesData,
    ourPrinciplesColumnData,
    featuredInData,
    blueSectionData,
    bottomSectionData,
    ourRecognitionData,
    ourRecognitionSliderData,
    recommendedReadsData,
    leadersData,
  } = aboutUsContent
  const { getTrustMarkerById } = useTrustMarkers()
  const trustPilot = getTrustMarkerById('truspilot')

  return (
    <Content>
      <WithSeoOverrides {...seo} />
      <Section classNames="pb-0 pt-0 lg:pl-4 xl:pl-0">
        <HeroSection
          {...heroData}
          contentClassName={styles.contentClassName}
          heroContainerClassName={styles.heroClassName}
          overlayShadowClassName={styles.overlayShadow}
          showNewTrustpilot
          trustPilotInfo={{
            rating: Number(trustPilot?.rating),
            totalReviews: numberFormat(Number(trustPilot?.totalReview)),
            link: trustPilot?.link,
            color: '#33b083',
          }}
          showScheduleACallButton={showScheduleACallButton}
        />
      </Section>
      <Section classNames="bg-blue-base-white">
        <BrandSection
          {...ourStoryData}
          childClassName="lg:col-span-10 lg:col-start-2"
        />
      </Section>
      <Section>
        <BrandSection
          {...ourPrinciplesData}
          childClassName="lg:col-span-10 lg:col-start-2"
        >
          <ColumnToRowComponent data={ourPrinciplesColumnData} />
        </BrandSection>
      </Section>
      <Section classNames="bg-blue-base-white">
        <AsFeaturedInComp items={featuredInData} />
      </Section>
      <Section classNames="bg-blue-base">
        <BlueSection {...blueSectionData} />
      </Section>
      <Section>
        <BrandSection {...ourRecognitionData}>
          <OurPrinciplesSlider data={ourRecognitionSliderData} />
        </BrandSection>
      </Section>
      <Section classNames="pb-0 pt-0 bg-blue-base-white">
        <RecommendedReads data={recommendedReadsData} />
      </Section>
      <Section classNames="bg-white">
        <Leaders data={leadersData} />
      </Section>
      <Section classNames="pb-0 pt-0">
        <BottomSection {...bottomSectionData} />
      </Section>
    </Content>
  )
}

export default AboutPage
